import React from "react";

const IconComponentMap={
  defaultEntityIcon:React.lazy(()=>import("@mui/icons-material/Folder")),
  homeIcon:React.lazy(()=>import("@mui/icons-material/Home")),
  accountIcon:React.lazy(()=>import("@mui/icons-material/AccountBox")),
  userIcon:React.lazy(()=>import("@mui/icons-material/People")),
  dataMgmtIcon:React.lazy(()=>import("@mui/icons-material/Storage")),
  serverMgmtIcon:React.lazy(()=>import("@mui/icons-material/Memory")),
  errorLogsIcon:React.lazy(()=>import("@mui/icons-material/BugReportOutlined")),
  notificationsIcon:React.lazy(()=>import("@mui/icons-material/Notifications")),
  appRolesIcon:React.lazy(()=>import("@mui/icons-material/AdminPanelSettingsOutlined")),
  appMenuIcon:React.lazy(()=>import("@mui/icons-material/AppsOutlined")),
  analysisRequestIcon:React.lazy(()=>import("@mui/icons-material/Pool")),
  guidelinesIcon:React.lazy(()=>import("@mui/icons-material/MenuBook")),
};

export const getIconComponent=(name)=>IconComponentMap[name]||null;
